/* eslint-disable quotes */
export const FRONTEND_ALERT_ERROR = 'FRONTEND_ALERT_ERROR';
export const FRONTEND_STACK = 'FRONTEND WEBAPP';
export const WRONG_ADDRESS = 'Votre adresse est incorrecte ou incomplète.';
export const UNAVAILABLE_ADDRESS =
  'Désolé, nous ne livrons pas dans cette zone actuellement.';
export const NO_SHOP_SELECTED_ERROR_MESSAGE =
  'Vous devez sélectionner un point de vente.';
export const NO_SHOP_AVAILABLE_ERROR_MESSAGE =
  "Malheureusement, aucun magasin n'est disponible actuellement.";

export const LEVELS = {
  INFO: 'info',
  ERROR: 'error',
};
export const SEVERITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};

export const EMAIL_ALREADY_USED_IN_FIREBASE_AUTH = 'Cette adresse email est déjà utilisée sur l’un de nos services.\n' +
  'Pour poursuivre, veuillez en saisir une autre.';
export const EMAIL_EMPTY_DATA_ACCOUNT = 'Aucune donnée n\'est associée à ce compte.\n Veuillez réessayer avec un email différent.'
